import PageTitle from "../../components/PageTitle/PageTitle";
import "./HelpPage.scss";
import { useState } from "react";
import ChangePassword from "../../assets/help/change_password_2.png";
import ChangePassword2 from "../../assets/help/change_password.png";
import Sessions from "../../assets/help/sessions.png";
import Unsanswered from "../../assets/help/unanswered.png";
import Bookings from "../../assets/help/bookings.png";
import FormChat from "../../assets/help/form_chat.png";
import Hotels from "../../assets/help/hotels.png";
import HotelChat from "../../assets/help/slider_hotel_chat.png";
import Restaurants from "../../assets/help/restaurants.png";
import RestaurantsChat from "../../assets/help/restaurants_chat.png";
import Events from "../../assets/help/events.png";
import EventsSlider from "../../assets/help/events_chat.png";
import Topics from "../../assets/help/topics.png";
import TopicsChat from "../../assets/help/topics_chat.png";
import Messages from "../../assets/help/messages.png";
import MessagesChat from "../../assets/help/messages_chat.png";
import Settings from "../../assets/help/settings.png";
import SettingsChat from "../../assets/help/messages_chat.png";
import WpPlugin from "../../assets/help/wp_plugin.png";
import Insert from "../../assets/help/insert.png";
import HeadPrint from "../../assets/help/head.png";

const contentMap = {
  Aceder: (
    <>
      <h3>Como aceder à plataforma</h3>
      <div className="flex">
        <img src={ChangePassword} alt="Login Page" />
        <img src={ChangePassword2} alt="Change Password" />
      </div>
      <p>
        Para iniciar sessão, aceda à{" "}
        <a href="panel.hoteisdigitais.com/login" target="_noblank">
          página de entrada da plataforma
        </a>{" "}
        e insira o <strong>nome de utilizador</strong> e a{" "}
        <strong>palavra-passe</strong> enviados previamente pela nossa equipa de
        suporte. Caso ainda não possua credenciais próprias, contacte-nos{" "}
        <a href="mailto:comercial@hoteisdigitais.com">aqui</a> para solicitar
        novas credenciais. Se recebeu uma palavra passe temporária, ser-lhe-á
        pedido que a altere no primeiro acesso por motivos de segurança.
      </p>
    </>
  ),
  "Consola de Atendimento": (
    <>
      <h3>Atendimento (consola do operador)</h3>
      <p>
        Menu principal → <strong>Atendimento</strong>. Disponível para{" "}
        <strong>hotel_admin</strong>, <strong>group_admin</strong> e{" "}
        <strong>operator</strong> — é aqui que se responde, em tempo real, aos
        hóspedes que pediram para <strong>falar com uma pessoa</strong> no
        chatbot.
      </p>
      <div className="green-bg">
        <p>
          <strong>Antes de usar:</strong> tem de estar inscrito como{" "}
          <strong>operador ativo</strong> do hotel (ver separador Operadores
          em <strong>Configurar Atendimento</strong>). Caso contrário, verá
          uma mensagem a pedir para contactar o administrador.
        </p>
      </div>
      <h4>Estado do operador</h4>
      <p>
        No topo, escolha o seu estado: <strong>Online</strong> (disponível
        para novas conversas), <strong>Ausente</strong> ou{" "}
        <strong>Offline</strong>.
      </p>
      <h4>Fila e Minhas conversas</h4>
      <ul>
        <li>
          <strong>Fila:</strong> pedidos ainda por atribuir. Clique em{" "}
          <strong>Reivindicar</strong> para assumir uma conversa — passa a
          aparecer em "Minhas conversas".
        </li>
        <li>
          <strong>Minhas conversas:</strong> conversas já atribuídas a si
          (atribuída/ativa). A lista e a fila atualizam-se automaticamente.
        </li>
      </ul>
      <h4>Conversar e fechar</h4>
      <p>
        Ao selecionar uma conversa, vê o histórico de mensagens e pode
        escrever a resposta para o hóspede. Quando o pedido estiver resolvido,
        use <strong>Fechar conversa</strong> — o hóspede volta a falar com o
        chatbot normalmente.
      </p>
    </>
  ),
  Sessões: (
    <>
      <h3>Página de Sessões</h3>
      <div className="flex">
        <img src={Sessions} alt="Sessions Page" />
      </div>
      <p>
        A página de sessões reúne todas as mensagens trocadas no chatbot,{" "}
        <strong>agrupadas por sessões</strong>.
      </p>
      <ul>
        <li>
          <strong>Uma sessão = um utilizador.</strong> Sempre que um novo
          utilizador inicia conversa, é criada uma sessão própria.
        </li>
        <li>
          <strong>
            Reutilização por IP. Se o utilizador regressar ao chatbot a partir
            do mesmo endereço de IP, as novas mensagens ficam{" "}
            <strong>associadas à sessão previamente criada</strong>, mantendo o
            histórico contínuo.
          </strong>
        </li>
      </ul>
      <h4>Como navegar</h4>
      <ol>
        <li>
          <strong>Lista de sessões (coluna esquerda):</strong> vê todas as
          sessões existitentes, identificadas pelo código/nome e data
        </li>
        <li>
          <strong>Mensagens (painel direito):</strong> ao selecionar uma sessão,
          é mostrada a cronologia completa das perguntas e respostas, com
          data/hora de cada mensagem.
        </li>
      </ol>
      <h4>Notas</h4>
      <ul>
        <li>
          A continuidade da sessão depende do IP do utilizador; se este mudar
          (por exemplo, redes diferentes), poderá ser criada
          <strong>uma nova sessão</strong>
        </li>
        <li>
          Utilize esta página para <strong>acompanhar conversas</strong>,
          analisar contexto e dar seguimento a interações anteriores do mesmo
          utilizador.
        </li>
      </ul>
    </>
  ),
  "Sem Resposta": (
    <>
      <h3>Página de Mensagens sem Resposta</h3>
      <div className="flex">
        <img src={Unsanswered} alt="Unanswered Page" />
      </div>
      <p>
        A página de <strong>Mensagens sem Resposta</strong> lista todas as
        perguntas em que o chatbot{" "}
        <strong>não teve confiança suficiente</strong> para responder ou{" "}
        <strong>não possuía dados</strong> para o fazer. Cada cartão mostra a{" "}
        <strong>mensagem original</strong>, a <strong>sessão</strong> a que
        pertencer e a <strong>data/hora</strong>, para que possa rever o
        contexto rapidamente.
      </p>
      <h4>Quando aparecem aqui</h4>
      <ul>
        <li>Falta de informação (ex: horários, distância, políticas).</li>
        <li>
          Respostas com <strong>baixa confiança</strong> do modelo
        </li>
        <li>
          Questões novas que <strong>não estão cobertas</strong> pelos
          tópicos/FAQ atuais.
        </li>
      </ul>
      <h4>Como utilizar</h4>
      <ul>
        <li>Abra cada sessão para ver o contexto associado à mensagem.</li>
        <li>
          Identifique o <strong>dado em falta</strong> ou regra de negócio que o
          bot precisa.
        </li>
        <li>
          Entre em contacto com o{" "}
          <a href="mailto:comercial@hoteisdigitais.com">suporte</a> para que
          possamos atualizar o seu sistema.
        </li>
        <li>
          Marque como <strong>resolvido</strong>(quando disponível) para manter
          a fila limpa.
        </li>
      </ul>
      <h4>Benefícios</h4>
      <ul>
        <li>
          Fecha lacunas de conhecimento e <strong>reduz falhas futuras</strong>.
        </li>
        <li>
          Melhora a <strong>taxa de resolução automática</strong> e a
          experiência dos <strong>hóspedes</strong>ao longo do tempo.
        </li>
      </ul>
      <h4>Nota</h4>
      <p>
        Mensagens podem surgir repetidas se a questão for recorrente; use-as
        como sinal para <strong>priorizar</strong> novos conteúdos ou
        automatizações.
      </p>
    </>
  ),
  Reservas: (
    <>
      <h3>Página de Reservas</h3>
      <div className="flex">
        <img src={Bookings} alt="Bookings Page" />
        <img src={FormChat} alt="Form Chat" />
      </div>
      <p>
        A página <strong>Bookings</strong> apresenta{" "}
        <strong>todas as submissões de formulário feitas no chatbot</strong> (o
        pedido de reserva dentro da conversa). Cada linha corresponde a um novo
        envio do utilizador e inclui os principais dados do pedido:
      </p>
      <ul>
        <li>
          <strong>Hotel</strong>
        </li>
        <li>
          <strong>Check-in & Check-out</strong>
        </li>
        <li>
          <strong>Noites</strong>
        </li>
        <li>
          <strong>Adultos, Crianças, Bebés</strong>
        </li>
        <li>
          <strong>Promocode</strong>(quando aplicado)
        </li>
      </ul>
      <h4>Como usar</h4>
      <ul>
        <li>
          Use o <strong>seletor de Hotel</strong> para filtrar os pedidos por
          unidade (caso haja mais de hotel no grupo).
        </li>
        <li>
          Revise a lista para identificar datas, ocupação e códigos promocionais
          utilizados.
        </li>
      </ul>
      <h4>Notas</h4>
      <ul>
        <li>
          Cada registo representa uma{" "}
          <strong>submissão do formulário do chatbot</strong>; não implica
          confirmação automática no seu PMS/engine, a menos que exista
          integração específica.
        </li>
        <li>
          Esta visão ajuda a acompanhar a <strong>intenção de reserva</strong>
          captada pelo chatbot.
        </li>
      </ul>
    </>
  ),
  Hotéis: (
    <>
      <h3>Página de Hotéis</h3>
      <div className="flex">
        <img src={Hotels} alt="Hotels Page" />
        <img src={HotelChat} alt="Hotels Chat" />
      </div>
      <p>
        A página de <strong>Hotéis</strong> centraliza a gestão de propriedades
        para o seu grupo. Aqui pode <strong>ver e editar</strong> informações de
        cada hotel (consoante as <strong>permissões</strong> do seu perfil).
      </p>
      <div className="green-bg">
        <p>
          <strong>Importante:</strong> os dados deste ecrã alimentam os
          sliders/cards mostrados no chatbot - garantir conteúdo correto e fotos
          de qualidade é essencial para a experiência dos utilizadores.
        </p>
      </div>
    </>
  ),
  Restaurantes: (
    <>
      <h3>Página de Restaurantes</h3>
      <div className="flex">
        <img src={Restaurants} alt="Restaurants Page" />
        <img src={RestaurantsChat} alt="Restaurants Chat" />
      </div>
      <p>
        A página de <strong>Restaurantes</strong> centraliza a gestão dos
        restaurantes e bares associados aos seus hotéis.
      </p>
      <div className="green-bg">
        <p>
          <strong>Importante:</strong> os dados e imagens deste ecrã alimentam
          os sliders/cards mostrados no chatbot - garantir conteúdo correto e
          fotos de qualidade é essencial para a experiência dos utilizadores.
        </p>
      </div>
      <h4>O que pode editar</h4>
      <ul>
        <li>
          <strong>Nome e Descrição</strong> nas línguas disponíveis.
        </li>
        <li>
          <strong>Fotografia</strong>.
        </li>
        <li>
          <strong>Localização</strong>.
        </li>
        <li>
          <strong>Criar novo</strong> ou <strong>eliminar</strong> um
          restaurante/bar — disponível para SuperAdmin, group_admin e
          hotel_admin.
        </li>
      </ul>
    </>
  ),
  Eventos: (
    <>
      <h3>Página de Eventos</h3>
      <div className="flex">
        <img src={Events} alt="Events Page" />
        <img src={EventsSlider} alt="Events Chat" />
      </div>
      <p>
        A página de <strong>Eventos</strong> centraliza a gestão das{" "}
        <strong>salas de reuniões e espaços para eventos</strong> do seu hotel.
      </p>
      <div className="green-bg">
        <p>
          <strong>Importante:</strong> os dados e imagens deste ecrã alimentam
          os sliders/cards mostrados no chatbot - garantir conteúdo correto e
          fotos de qualidade é essencial para a experiência dos utilizadores.
        </p>
      </div>
      <h4>O que pode editar</h4>
      <ul>
        <li>
          <strong>Nome e Descrição</strong> nas línguas disponíveis.
        </li>
        <li>
          <strong>Fotografia</strong>.
        </li>
        <li>
          <strong>Localização</strong>.
        </li>
        <li>
          <strong>Criar nova</strong> ou <strong>eliminar</strong> uma sala de
          eventos — disponível para SuperAdmin, group_admin e hotel_admin.
        </li>
      </ul>
    </>
  ),
  Tópicos: (
    <>
      <h3>Página de Tópicos</h3>
      <div className="flex">
        <img src={Topics} alt="" />
        <img src={TopicsChat} alt="" />
      </div>
      <p>
        A página <strong>Tópcicos</strong> guarda{" "}
        <strong>respostas rápidas</strong> em <strong>PT/EN/ES</strong>. Cada
        tópico tem um <strong>título</strong> e uma <strong>mensagem</strong>{" "}
        (nos 3 idiomas) e pode ser chamado pelo chatbot para responder de forma
        imediata a perguntas recorrentes (ex: pequeno-almoço, check-in/out,
        estacionamento, Wi-Fi, ofertas, etc.). Todos os campos são{" "}
        <strong>editáveis</strong> pelos utilizadores.
      </p>
      <ul>
        <li>
          Os campos têm um <strong>limite de caracteres</strong> (com contador
          visível) para evitar erros ao guardar.
        </li>
        <li>
          Pode <strong>ativar/desativar</strong> um tópico sem o apagar — fica
          fora do menu do chatbot, mas mantém-se guardado no backoffice.
        </li>
      </ul>
    </>
  ),
  Mensagens: (
    <>
      <h3>Página de mensagens fixas</h3>
      <div className="flex">
        <img src={Messages} alt="Messages Page" />
        <img src={MessagesChat} alt="Messages Chat" />
      </div>
      <p>
        As <strong>mensagens fixas</strong> são textos curtos que aparecem entre
        os <strong>fluxos de botões</strong> do chatbot (ex: saudação inicial,
        pergunta "Em que posso ajudar?", transições entre passos). São{" "}
        <strong>costumizáveis</strong> em PT/EN/ES e influenciam diretamente na
        experiência do utilizador.
      </p>
      <div className="green-bg">
        <p>
          <strong>Atenção:</strong> estas mensagens dão{" "}
          <strong>coêrencia</strong> ao fluxo. Atlere com{" "}
          <strong>cautela</strong> para não criar contradições com os botões nem
          "buracos" de conversa.
        </p>
      </div>
    </>
  ),
  Definições: (
    <>
      <h3>Página de definições</h3>
      <div className="flex">
        <img src={Settings} alt="Settings Page" />
        <img src={SettingsChat} alt="Settings Chat" />
      </div>
      <p>
        A página de <strong>Definições</strong> controla o{" "}
        <strong>aspeto do chat</strong> que aparece no seu site. Aqui pode
        ajudar cores, textos e ícones. Alterações visuais impactam diretamente a
        legibilidade e a conversão do CTA, por isso recomendamos testar após
        cada alteração.
      </p>
      <h4>Elementos configuráveis</h4>
      <ul>
        <li>
          <strong>Título</strong>: texto que aparece no <strong>header</strong>{" "}
          do chat. Use um nome curto e claro.
        </li>
        <li>
          <strong>cor "Book now" (CTA):</strong> cor do botão de{" "}
          <strong>reserva</strong> no header. Deve <strong>destacar-se</strong>{" "}
          do resto do da paleta para maximizar cliques.
        </li>
        <li>
          <strong>Cor primária:</strong> aplicada ao <strong>header</strong> do
          chat. Deve combinar com a identidade do hotel e manter{" "}
          <strong>bom constraste</strong> com o título e ícones.
        </li>
        <li>
          <strong>Cor secundária:</strong> usada nos botões (ex: Reservar
          estadia, "Restaurantes"). O texto dos botões é <strong>branco</strong>{" "}
          - escolha uma cor com contraste suficiente para leitura.
        </li>
        <li>
          <strong>Cor terciária:</strong> <strong>fundo</strong> da área de
          conversa. Prefira tons <strong>claros</strong> para valorizar as
          mensagens e as imagens.
        </li>
        <li>
          <strong>Cor da bubble:</strong> cor do{" "}
          <strong>botão flutuante</strong> que abre o chat. Deve ser visível
          sobre o seu site e coerente com a marca.
        </li>
        <li>
          <strong>Cor da mensagem do agente e da mensagem do visitante:</strong>{" "}
          cores dos <strong>balões da conversa</strong>. O texto dentro dos
          balões é <strong>preto</strong> - evite <strong>cores escuras</strong>{" "}
          ou saturadas que prejudiquem a leitura.
        </li>
        <li>
          <strong>Ícone da bubble:</strong> ícone exibido no botão de abertura
          do chat. Utilize imagem <strong>quadrada</strong>pequena com fundo
          transparente, se possível.
        </li>
        <li>
          <strong>Ícone do header (favicon do chat):</strong> ícone pequeno
          apresentado no topo do chat. Use versões simples do logotipo para boa
          legibilidade, com fundo transparente e tamanhos reduzidos.
        </li>
      </ul>
    </>
  ),
  Módulos: (
    <>
      <h3>Módulos (Licenciamento) — apenas SuperAdmin</h3>
      <p>
        A página <strong>Módulos</strong> é o painel central onde o SuperAdmin
        liga ou desliga funcionalidades por hotel. Existem dois tipos de
        módulos na plataforma:
      </p>
      <h4>Restaurantes e Salas de Eventos (conteúdo do widget)</h4>
      <p>
        Controlados diretamente nesta página (Definições → Módulos). Cada
        linha é um hotel, com uma checkbox para <strong>Restaurantes</strong>{" "}
        e outra para <strong>Salas de Eventos</strong>.
      </p>
      <ul>
        <li>
          Um hotel <strong>sem nenhum registo configurado</strong> aparece
          marcado por defeito (comportamento atual mantido).
        </li>
        <li>
          <strong>Desmarcar</strong> oculta o conteúdo no widget de chat{" "}
          <strong>sem apagar os dados</strong> já criados.
        </li>
        <li>
          A indicação <strong>"sem dados criados"</strong> a laranja significa
          que o módulo está ativo, mas o hotel ainda não tem nenhum
          restaurante/sala criado em Admin → Restaurantes/Eventos — o botão
          não aparece no widget até lá, independentemente do toggle.
        </li>
      </ul>
      <h4>Atendimento, Satisfação e Upselling (módulos de licença)</h4>
      <p>
        O <strong>Atendimento Humano</strong>, a{" "}
        <strong>Satisfação (CSAT)</strong> e o{" "}
        <strong>Upselling (AI Revenue Agent)</strong> são módulos com
        licenciamento próprio por hotel. Não são geridos aqui — são ligados
        diretamente no topo de cada ecrã de configuração respetivo
        (Definições → Configurar Atendimento / Satisfação / Upselling), onde
        o SuperAdmin vê um estado <strong>"Módulo licenciado"</strong> ou{" "}
        <strong>"Módulo não licenciado"</strong> e um botão para alternar.
      </p>
      <div className="green-bg">
        <p>
          <strong>Importante:</strong> enquanto um destes módulos não estiver
          licenciado para um hotel, os administradores de grupo/hotel veem uma
          mensagem a pedir para contactar um SuperAdmin e não conseguem aceder
          às definições desse módulo.
        </p>
      </div>
    </>
  ),
  "Sincronização de Conteúdos": (
    <>
      <h3>Sincronização de Conteúdos — apenas SuperAdmin</h3>
      <p>
        Mantém o <strong>conhecimento do chatbot</strong> alinhado com o
        website do grupo. Dispara o crawler que lê o site e atualiza os
        conteúdos usados nas respostas — <strong>sem tocar</strong> em
        FAQ, HTML ou conteúdos manuais.
      </p>
      <div className="green-bg">
        <p>
          <strong>Só SuperAdmin</strong> pode acionar sincronizações — cada
          disparo tem custo de API (embeddings) e reindexa a base de
          conhecimento do grupo, por isso não fica acessível a group_admin/
          hotel_admin.
        </p>
      </div>
      <h4>Onde encontrar</h4>
      <p>
        Definições → <strong>Sincronização de Conteúdos</strong>. Escolha
        primeiro o <strong>grupo</strong> no seletor no topo.
      </p>
      <h4>Separador Estado</h4>
      <ul>
        <li>
          <strong>Cartão Website:</strong> mostra o URL configurado no grupo,
          o estado da última sincronização e um botão{" "}
          <strong>Sincronizar Website</strong> — volta a percorrer todo o
          site e atualiza apenas os conteúdos de origem "website" (FAQs e
          HTML nunca são apagados).
        </li>
        <li>
          <strong>Cartão Eventos & Promoções:</strong> sincronização rápida,
          restrita apenas às páginas marcadas como Eventos/Promoções (ver
          separador Fontes). O botão só fica ativo com pelo menos uma fonte
          configurada.
        </li>
        <li>
          Enquanto uma sincronização decorre, o botão mostra{" "}
          <strong>"A sincronizar…"</strong> e fica desativado até terminar;
          não é possível iniciar duas sincronizações em simultâneo para o
          mesmo grupo.
        </li>
        <li>
          <strong>Histórico de Sincronizações:</strong> tabela com data,
          tipo, estado (sucesso/erro/aviso), páginas processadas, conteúdos
          indexados/removidos, duração e mensagem de erro (quando aplicável).
        </li>
      </ul>
      <h4>Separador Fontes de Eventos & Promoções</h4>
      <p>
        Defina quais as páginas do website que pertencem a Eventos/Promoções
        (ex: <strong>/eventos/</strong>, <strong>/ofertas/</strong>, ou um
        URL completo). Cada fonte tem um padrão de URL, descrição opcional e
        estado ativo/inativo; pode <strong>editar</strong> ou{" "}
        <strong>eliminar</strong> a qualquer momento.
      </p>
    </>
  ),
  Atendimento: (
    <>
      <h3>Configurar Atendimento (Atendimento Humano)</h3>
      <p>
        Este módulo permite que um hóspede, a meio da conversa no chatbot,
        peça para <strong>falar com uma pessoa</strong>. O pedido entra numa
        fila e é atribuído a um <strong>operador humano</strong>, que responde
        através da consola de <strong>Atendimento</strong> (menu principal,
        para hotel_admin/group_admin/operator).
      </p>
      <div className="green-bg">
        <p>
          <strong>Antes de configurar:</strong> o SuperAdmin tem de licenciar o
          módulo <strong>Atendimento Humano</strong> para o hotel (badge e
          botão no topo deste ecrã, ou ver <strong>Módulos</strong>).
        </p>
      </div>
      <h4>Onde encontrar</h4>
      <p>
        Definições → <strong>Configurar Atendimento</strong>. Se tiver acesso
        a mais do que um hotel, escolha primeiro o hotel no seletor no topo.
      </p>
      <h4>Separador Definições</h4>
      <ul>
        <li>
          <strong>Atendimento operacional:</strong> liga/desliga a fila para
          os hóspedes — com isto desligado, o pedido de falar com uma pessoa
          não aparece no widget.
        </li>
        <li>
          <strong>Recolher contacto do hóspede</strong> antes de entrar na
          fila (ex: nome/telefone).
        </li>
        <li>
          <strong>Pedir avaliação</strong> ao hóspede no fecho da conversa.
        </li>
        <li>
          <strong>Timeout de inatividade (segundos):</strong> tempo sem
          resposta até a conversa ser fechada automaticamente.
        </li>
        <li>
          <strong>Aviso de fila a partir de (opcional):</strong> nº de pedidos
          em fila a partir do qual o hóspede é avisado do tempo de espera.
        </li>
        <li>
          <strong>Mensagens costumizáveis:</strong> boas-vindas, fora de
          horário, fila de espera e conversa fechada.
        </li>
      </ul>
      <h4>Separador Departamentos</h4>
      <p>
        Departamentos organizam o encaminhamento dos pedidos (ex: Receção,
        Reservas). Cada um tem <strong>nome</strong>,{" "}
        <strong>descrição</strong> e <strong>ordem de encaminhamento</strong>.
        Desativar um departamento não o apaga — apenas deixa de poder ser
        escolhido.
      </p>
      <h4>Separador Operadores</h4>
      <ul>
        <li>
          <strong>Inscrever utilizador existente:</strong> transforma um
          utilizador já criado (Admin → Utilizadores) num operador de
          atendimento.
        </li>
        <li>
          <strong>Criar colaborador:</strong> cria uma conta nova (username,
          nome, email, password) já como operador, sem passar por
          Utilizadores.
        </li>
        <li>
          Para cada operador pode definir o{" "}
          <strong>nome a mostrar ao hóspede</strong>, o{" "}
          <strong>nº máximo de conversas simultâneas</strong> e os{" "}
          <strong>departamentos</strong> a que responde.
        </li>
        <li>
          Desativar um operador não apaga o histórico — apenas deixa de
          receber novas conversas.
        </li>
      </ul>
    </>
  ),
  Satisfação: (
    <>
      <h3>Configurar Satisfação (CSAT)</h3>
      <p>
        Este módulo pede ao hóspede uma <strong>avaliação rápida</strong> no
        fim da conversa com o chatbot, para medir a satisfação com o
        atendimento.
      </p>
      <div className="green-bg">
        <p>
          <strong>Antes de configurar:</strong> o SuperAdmin tem de licenciar o
          módulo <strong>CSAT</strong> para o hotel (badge e botão no topo
          deste ecrã, ou ver <strong>Módulos</strong>).
        </p>
      </div>
      <h4>Onde encontrar</h4>
      <p>
        Definições → <strong>Configurar Satisfação</strong>. Se tiver acesso a
        mais do que um hotel, escolha primeiro o hotel no seletor no topo.
      </p>
      <h4>O que pode configurar</h4>
      <ul>
        <li>
          <strong>Ativar inquérito no widget:</strong> liga/desliga o pedido
          de avaliação no final da conversa.
        </li>
        <li>
          <strong>Pedir comentário nas avaliações 1–2:</strong> quando o
          hóspede dá uma nota baixa, o chatbot pergunta o motivo.
        </li>
        <li>
          <strong>Oferecer operador em avaliações negativas:</strong> propõe
          falar com um humano após uma avaliação baixa — só fica disponível se
          o módulo <strong>Atendimento Humano</strong> também estiver
          licenciado para este hotel.
        </li>
        <li>
          <strong>Pergunta</strong> e <strong>Agradecimento:</strong> textos
          costumizáveis em PT/EN/ES mostrados ao hóspede.
        </li>
      </ul>
    </>
  ),
  Upselling: (
    <>
      <h3>Configurar Upselling (AI Revenue Agent)</h3>
      <p>
        Este módulo permite que o chatbot <strong>identifique oportunidades</strong>{" "}
        durante a conversa (ex: o hóspede pergunta por um transfer ou um
        upgrade) e <strong>ofereça produtos/serviços extra</strong> do seu
        catálogo, gerando receita adicional (upsell).
      </p>
      <div className="green-bg">
        <p>
          <strong>Antes de configurar:</strong> o SuperAdmin tem de licenciar o
          módulo <strong>AI Revenue Agent</strong> para o hotel (badge e
          botão no topo deste ecrã, ou ver <strong>Módulos</strong>).
        </p>
      </div>
      <h4>Onde encontrar</h4>
      <p>
        Definições → <strong>Configurar Upselling</strong>. Se tiver acesso a
        mais do que um hotel, escolha primeiro o hotel no seletor no topo.
      </p>
      <h4>Separador Definições</h4>
      <p>
        Contacto geral (WhatsApp, Telefone, Email) usado como reserva quando
        um produto não tem contacto próprio configurado.
      </p>
      <h4>Separador Catálogo</h4>
      <p>
        Aqui cria e gere os <strong>produtos/serviços</strong> a oferecer.
        Cada produto tem:
      </p>
      <ul>
        <li>
          <strong>Imagem, categoria e prioridade</strong> (ordem de exibição).
        </li>
        <li>
          <strong>Nome, descrição curta e descrição comercial</strong> em
          PT/EN/ES.
        </li>
        <li>
          <strong>Preço, moeda, IVA</strong> e opção de mostrar como
          "Desde...".
        </li>
        <li>
          <strong>Disponibilidade:</strong> sempre disponível, ou restrita a
          dias/horas específicas.
        </li>
        <li>
          <strong>Contacto próprio</strong> (opcional) — sobrepõe-se ao
          contacto geral definido em Definições.
        </li>
        <li>
          <strong>Modos de conversão:</strong> quais as opções mostradas ao
          hóspede para avançar — "Tenho interesse", falar com operador,
          WhatsApp, telefone ou link externo.
        </li>
        <li>
          <strong>Contextos (intents):</strong> disponível ao editar um
          produto já criado — frases/palavras-chave que ajudam a IA a
          detetar quando um hóspede está interessado neste produto. Pode
          adicionar manualmente ou usar <strong>"Gerar com IA"</strong> para
          obter sugestões.
        </li>
      </ul>
      <p>
        Desativar um produto não o apaga — apenas deixa de ser oferecido; pode
        ser reativado a qualquer momento.
      </p>
      <h4>Separador Oportunidades</h4>
      <p>
        Lista as oportunidades comerciais detetadas pela IA, com o respetivo
        estado: <strong>Detetada, Oferecida, Interessado, Contacto pedido,
        Confirmada, Recusada, Expirada</strong> ou <strong>Cancelada</strong>.
        Pode filtrar por estado. Para oportunidades em aberto, pode{" "}
        <strong>Confirmar</strong> (indicando o valor final da venda) ou{" "}
        <strong>Recusar</strong>.
      </p>
      <h4>Separador Analytics</h4>
      <p>
        Mostra o funil comercial (deteções → ofertas → interesses →
        confirmadas), a <strong>taxa de conversão</strong>, a{" "}
        <strong>receita confirmada e potencial</strong>, o{" "}
        <strong>ticket médio</strong>, a performance por produto e as
        oportunidades perdidas — útil para perceber quais produtos vendem
        melhor e onde ajustar preço, contexto ou disponibilidade.
      </p>
    </>
  ),
  "Widget do Chat": (
    <>
      <h3>Novidades do Widget do Chat</h3>
      <p>
        Funcionalidades recentes no widget que aparece no seu site, pensadas
        para dar mais controlo ao hóspede durante a conversa.
      </p>
      <h4>Menu "⋯" no cabeçalho</h4>
      <p>
        Ao lado do botão de fechar, um menu de três pontos reúne:
      </p>
      <ul>
        <li>
          <strong>Idioma (Português/English/Español):</strong> o widget deteta
          automaticamente o idioma da página (via <code>&lt;html lang&gt;</code>{" "}
          e/ou o URL), mas o hóspede pode trocar manualmente a qualquer
          momento. Trocar idioma reinicia a saudação/menu inicial já
          traduzidos.
        </li>
        <li>
          <strong>Transferir conversa:</strong> o hóspede pode descarregar o
          histórico da conversa como ficheiro <code>.txt</code>.
        </li>
        <li>
          <strong>Reiniciar conversa:</strong> equivalente ao botão de
          refresh, mas agora acessível também a partir deste menu.
        </li>
      </ul>
      <h4>Feedback nas respostas do bot</h4>
      <p>
        Sob uma resposta livre do chatbot (perguntas feitas por texto, fora
        dos botões do menu), aparece "Esta resposta esclareceu a sua
        dúvida?" com dois botões (👍/👎). Ajuda a identificar respostas que
        precisam de melhoria.
      </p>
      <h4>Aviso de inatividade com opções</h4>
      <p>
        O aviso proativo mostrado a meio de uma conversa parada (editável em{" "}
        <strong>Mensagens</strong>) passa agora a vir acompanhado de dois
        botões:
      </p>
      <ul>
        <li>
          <strong>"Estou bem por agora":</strong> dispensa o aviso sem sair
          da conversa.
        </li>
        <li>
          <strong>"Falar com o Staff":</strong> pede diretamente atendimento
          humano, tal como o CTA de Atendimento.
        </li>
      </ul>
      <div className="green-bg">
        <p>
          <strong>Importante:</strong> "Falar com o Staff" só entra
          efetivamente na fila de atendimento se o módulo{" "}
          <strong>Atendimento Humano</strong> estiver licenciado e ativo para
          o hotel (ver <strong>Atendimento</strong> e{" "}
          <strong>Módulos</strong>).
        </p>
      </div>
      <h4>Avatar no indicador "a escrever…"</h4>
      <p>
        Os três pontos que indicam que o bot está a preparar uma resposta
        passam a mostrar, ao lado, o mesmo ícone configurado em{" "}
        <strong>Definições → Ícone do header</strong>.
      </p>
    </>
  ),
  "Inserir widget": (
    <>
      <h3>Inserir widget</h3>
      <div className="flex">
        <img src={Insert} alt="Insert Widget" />
        <img src={WpPlugin} alt="Plugin Headers and Footers" />
      </div>
      <p>
        O widget é carregado via CSS + JS no &lt;head&gt; do website. Pode
        instalar de duas formas:
      </p>
      <ul>
        <li>
          <strong>WordPress</strong>: com o plugin WP Headers and Footers.
        </li>
        <li>
          <strong>Website desenvolvido de raiz (qualquer stack):</strong>{" "}
          inserir diretamente no &lt;head&gt;
        </li>
      </ul>
      <h4>WordPress (WP Headers and Footers)</h4>
      <ul>
        <li>
          Em <strong>Plugins &rarr; Add New</strong>, instale e ative{" "}
          <strong>WP Headers and Footers</strong>.
        </li>
        <li>
          Vá a{" "}
          <strong>
            Settings &rarr; Header & Footer &rarr; Scripts in Header
          </strong>
          .
        </li>
        <li>
          Cole o snippet abaixo (CSS + JS) e <strong>Save</strong>.
        </li>
        <li>Limpe caches (plugin/cdn/servidor) e teste em páginas públicas.</li>
      </ul>
      <h4>Outros websites (qualquer stack):</h4>
      <p>
        Insira o mesmo snippet <strong>dentro de &lt;head&gt;</strong> com o
        widget:
      </p>
      <h4>
        Frameworks modernos Single-Page-Application (React/Vue/Next/Nuxt):
      </h4>
      <div className="flex">
        <img src={HeadPrint} alt="Head Print" />
      </div>
      <ul>
        <li>
          <strong>React/CRA/Vite:</strong> coloque o snippet em
          public/index.html.
        </li>
        <li>
          <strong>Next.js:</strong> use _document.tsx dentro
          &lt;Head&gt;...&lt;/Head&gt;.
        </li>
      </ul>
    </>
  ),
};

export default function HelpPage() {
  const [selectedItem, setSelectedItem] = useState("Aceder");
  const handleClick = (item) => {
    setSelectedItem(item);
  };
  return (
    <div className="help-page">
      <PageTitle title="Ajuda"></PageTitle>
      <div className="container">
        <div className="intro">
          <div className="intro-container">
            <p>
              Bem-vindo ao <strong>Manual do Utilizador</strong> do Backoffice
              de gestão do ChatBot da HoteisDigitais. Este guia foi criado para
              o ajudar a começar rapidamente e a tirar o máximo proveito das
              funcionalidades, com instruções simples, exemplos práticos e
              soluções para os problemas mais comuns.
            </p>
          </div>
        </div>
        <div className="two-rows">
          <aside className="index">
            <ul className="menu">
              <li
                onClick={() => handleClick("Aceder")}
                className={`item ${
                  selectedItem === "Aceder" ? "selected" : ""
                }`}
              >
                <span>Aceder</span>
              </li>
              <li className="title">Páginas</li>
              {[
                "Consola de Atendimento",
                "Sessões",
                "Sem Resposta",
                "Reservas",
                "Hotéis",
                "Restaurantes",
                "Eventos",
                "Tópicos",
                "Mensagens",
                "Definições",
              ].map((item) => (
                <li
                  key={item}
                  className={`item ${selectedItem === item ? "selected" : ""}`}
                  onClick={() => handleClick(item)}
                >
                  {item}
                </li>
              ))}

              <li className="title">Novos módulos</li>
              {[
                "Atendimento",
                "Satisfação",
                "Upselling",
                "Módulos",
                "Sincronização de Conteúdos",
                "Widget do Chat",
              ].map(
                (item) => (
                  <li
                    key={item}
                    className={`item ${
                      selectedItem === item ? "selected" : ""
                    }`}
                    onClick={() => handleClick(item)}
                  >
                    {item}
                  </li>
                ),
              )}

              <li
                onClick={() => handleClick("Inserir widget")}
                className={`item ${
                  selectedItem === "Inserir widget" ? "selected" : ""
                }`}
              >
                Inserir widget
              </li>
            </ul>
          </aside>
          <aside className="content">{contentMap[selectedItem]}</aside>
        </div>
      </div>
    </div>
  );
}
